module.exports = __webpack_public_path__ + "img/Pinjaman-Tersalurkan.f537c0aa.svg";